import styled from 'styled-components';
export const RadioContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: transparent;

  &:active {
    ${({ isDisabled, theme }) => !isDisabled &&
    `
    background-color:${theme.colors.background.light}
    `}
  }
`;
export const MiddleCircle = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2rem;
  height: 2rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};
  border: ${({ isChecked, theme }) => isChecked
    ? `1px solid ${theme.colors.borders.highlight};`
    : `1.5px solid ${theme.colors.borders.default};`};
  ${({ isDisabled, theme }) => isDisabled && ` border:1px solid ${theme.colors.borders.disabled};`};

  background-color: ${({ isDisabled, isChecked, theme }) => (isDisabled || !isChecked) && `${theme.colors.surface.interactiveDefault}`};

  &:hover {
    ${({ isDisabled, isChecked, theme }) => !isDisabled &&
    `background-color: ${theme.colors.surface.interactiveDefault};
      ${!isChecked && `border: 1px solid ${theme.colors.borders.highlight};`}`}
  }
  &:active {
    ${({ isDisabled, isChecked, theme }) => !isDisabled &&
    `background-color: ${theme.colors.surface.interactiveDefault};
      ${!isChecked &&
        `border: 1px solid ${theme.colors.borders.highlight};
      `}`}
  }
`;
export const InnerCircle = styled.div `
  width: 0.8rem;
  height: 0.8rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ isDisabled, theme }) => isDisabled
    ? `${theme.colors.borders.disabled}`
    : `${theme.colors.interactive.brandColor}`};
`;
//# sourceMappingURL=styles.js.map